import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useTiposEmpreendimentos() {
  const fetchData = async () => {
    const LISTAR_TIPOS_EMPREENDIMENTOS = `locais/mobile/tipos-empreendimentos/v1`;
    const response = await instance.get(LISTAR_TIPOS_EMPREENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_tipos_empreendimentos"],
    refetchOnMount: false,
    enabled: true,
  });
  return query;
}
